import BaseView from 'components-framework/view/base.view';
import withCachedSelectors from 'components-framework/view/with_cached_selectors';
import {hasRememberMeCookie} from 'od-modules/utils/sso.utils';
import {replaceAllParamsInKeys} from './utils';
import {isAccountActive, getResultFullFareSelected} from 'od-modules/utils/membership_utils';
import {isSelectedFlightChangeableForFree} from 'od-modules/utils/flight_change_free';
const creditCardUtils = require('od-modules/utils/credit_card.utils');

import {
    OFFER_ZERO,
    OFFER_TYPES,
    SIGN_MINUS,
    SIGN_PLUS,
    OFFERS,
    EMPTY_STRING,
    TRACKING,
    REQUEST_FOR_RISKY_CC_TIMEOUT,
} from './constants';
const isUserLogged = () => hasRememberMeCookie();
const trackingUtils = require('od-modules/utils/tracking.utils');
const isPrimeWidgetStepOpenFirstTime = () => Odigeo.Utils.parseJson(Odigeo.Session.get('isPrimeWidgetStepOpenFirstTime'));
const isDynpack = Odigeo.Utils.isRequestApp('dp');
const page = isDynpack ? 'dp-anc' : 'anc';
const trackingCategory = isDynpack ? TRACKING.DYNPACK_CATEGORY : TRACKING.CATEGORY;
const pendingPrimeDecisionMessage = '.pending_prime_decision_message';

export const MembershipAncillariesView = withCachedSelectors(BaseView.extend({
    events: {
        'click .membership_ancillaries_radio_input': 'onChangeOffer',
        'click .membership_ancillaries_selectable': 'onChangeOffer',
        'click .membership_ancillaries_open_login': 'onOpenLoginForm',
        'click .membership_ancillaries_open_terms': 'onTermsConditions',
    },
    selectors: {
        errorMessage: 'membership_ancillaries_error_message',
        fullMembershipBox: '.membership_ancillaries_area_input_FULL_FARE',
        primeMembershipBox: '.membership_ancillaries_area_input_PRIME_FARE',
        header: '.membership_ancillaries_header',
        primeFareOffer: '.membership_ancillaries_offer_0',
        fullFareOffer: '.membership_ancillaries_offer_1',
        offerHeader: '.offer_header_component',
        offerBenefits: '.offer_benefits_component',
        offerKNowMore: '.offer_know_more_component',
        offerDescription: '.offer_description_component',
        offerWarning: '.offer_warning_component',
        offerFooter: '.offer_footer_component',
        membershipAncillariesWarning: '.membership_ancillaries_warning',
        membershipAncillariesInputFullFare: '.membership_ancillaries_radio_input[data-offer="FULL_FARE"]',
        membershipAncillariesInputPrimeFare: '.membership_ancillaries_radio_input[data-offer="PRIME_FARE"]',
        offerPrimeFareAskLogin: '.membership_ancillaries_force_login',
        offerPrimeFarePositiveMessageContainer: '.membership-ancillaries-prime-fare-message-container',
        offerBenefitsList: '.membership_ancillaries_benefits_list',
    },
    render({isPrimeFareSelected, membershipDiscount, keys}) {
        this.keys = keys || this.keys;
        this.updatedKeys = this.getUpdatedKeys(membershipDiscount);
        const errorMessageComponent = this.buildErrorMessageTemplate();
        const headerComponent = this.buildHeaderTemplate();
        const isPrimeDecisionTaken = this.model.get('isPrimeDecisionTaken');
        const {isMeta} = Odigeo.SessionScope;
        const isDisablePrechecked = (!isMeta && !isPrimeDecisionTaken) || this.isFreeTrialMetaRevamp();

        this.model.set('isDisablePrechecked', isDisablePrechecked);
        let offerComponents = [];
        OFFERS.forEach((offerType) => {
            offerComponents.push(
                this.buildOfferTemplate({
                    isPrimeFareSelected,
                    offerType,
                    membershipDiscount,
                    isDisablePrechecked,
                }),
            );
        });
        const wrapperTemplate = this.buildWrapperTemplate({
            errorMessageComponent,
            headerComponent,
            offerComponents,
        });
        this.$el.html(wrapperTemplate);
        this.updateDomSelectorsToCache();
        if (isMeta && !this.isFreeTrialMetaRevamp()) {
            this.trackRender();
        } else {
            this.toggleHiddenClassMembershipAncillariesWidget();
            this.model.set('isSubscriptionAdded', null);
            this.toggleAskLoginText();
        }
    },
    getUpdatedKeys(membershipDiscount) {
        const {price, renewalPrice, renewalDuration} = this.model.get('membershipOffer');
        return replaceAllParamsInKeys(this.keys, price, membershipDiscount, renewalPrice, 0, renewalDuration, 'MONTHS');
    },
    toggleShowMembershipAncillariesWidget() {
        this.toggleHiddenClassMembershipAncillariesWidget();
        if (isPrimeWidgetStepOpenFirstTime()) {
            this.trackRenderWithoutPage();
        }
    },
    toggleHiddenClassMembershipAncillariesWidget() {
        const isPrimeWidgetStepAlreadyOpened = isPrimeWidgetStepOpenFirstTime();
        this.$el.toggleClass('odf-hidden', !isPrimeWidgetStepAlreadyOpened);
    },
    buildWrapperTemplate({errorMessageComponent, headerComponent, offerComponents}) {
        return this.templates.wrapper({
            errorMessageComponent,
            headerComponent,
            offerComponents,
        });
    },
    buildErrorMessageTemplate() {
        const {selectionWarningMessage} = this.updatedKeys;
        const subscriptionMandatoryTitle = selectionWarningMessage;
        return this.templates.errorMessage({subscriptionMandatoryTitle});
    },
    buildHeaderTemplate() {
        const isFreeTrialAbuser = this.isFreeTrialAbuser();
        const isMembershipFlexibilityD = Odigeo.Membership.isMembershipFlexibilityD;
        const {headerTitle, offerMembershipHeaderTitlePill, abuseTitle, abuseDescription} = this.updatedKeys;
        const headerTitleText = headerTitle;
        return this.templates.header({
            headerTitleText,
            offerMembershipHeaderTitlePill,
            isFreeTrialAbuser,
            abuseTitle,
            abuseDescription,
            isMembershipFlexibilityD,
        });
    },
    buildOfferTemplate({isPrimeFareSelected, offerType, membershipDiscount, isDisablePrechecked}) {
        const userStatus = this.model.get('userStatus');
        const hasBasicAccount = isAccountActive(userStatus);
        const headerComponent = this.buildOfferHeaderTemplate({
            isPrimeFareSelected,
            membershipDiscount,
            offerType,
            isDisablePrechecked,
        });
        const benefitsComponent = this.buildOfferBenefitsComponent({offerType});
        const knowMoreComponent = this.buildOfferKnowMoreTemplate({offerType});
        const footerComponent = this.buildOfferFooterTemplate({offerType, hasBasicAccount});
        const descriptionComponent = this.buildOfferDescriptionTemplate({offerType, isFullFareChecked: !isPrimeFareSelected});
        const warningComponent = this.buildOfferWarningTemplate({offerType, isFullFareChecked: !isPrimeFareSelected, membershipDiscount});
        const isFreeTrialAbuser = this.isFreeTrialAbuser();
        return this.templates.offer({
            offerType,
            isFreeTrialAbuser,
            headerComponent,
            benefitsComponent,
            footerComponent,
            knowMoreComponent,
            descriptionComponent,
            warningComponent,
        });
    },
    buildOfferHeaderTemplate({isPrimeFareSelected = false, offerType, membershipDiscount, isDisablePrechecked}) {
        const isFreeTrialAbuser = this.isFreeTrialAbuser();
        const fareDiscount = this.buildFareDiscount({isPrimeFareSelected, offerType, membershipDiscount});
        const {offerPrimeFareHeaderTitle, abuseBlueMessage, offerFullFareHeaderTitle,
            primeFlexibilityPill, offerMembershipHeaderTitlePill, travellersMembers} = this.updatedKeys;
        const isPrimeFare = offerType === OFFER_TYPES.PRIME_FARE;
        const offerHeaderTitle = isPrimeFare
            ? offerPrimeFareHeaderTitle
            : offerFullFareHeaderTitle;
        const isChecked = ((isPrimeFareSelected && isPrimeFare) ||
            (!isPrimeFareSelected && offerType === OFFER_TYPES.FULL_FARE)) && !isDisablePrechecked;
        const isFlexibility = isPrimeFare && Odigeo.Membership.isMembershipFlexibilityD;
        return this.templates.offerHeader({
            fareDiscount,
            offerHeaderTitle,
            isPrimeFareSelected,
            offerType,
            abuseBlueMessage,
            isPrimeFare,
            isFlexibility,
            primeFlexibilityPill,
            offerMembershipHeaderTitlePill,
            isFreeTrialAbuser,
            travellersMembers,
            checked: isChecked ? 'checked' : '',
        });
    },
    buildOfferBenefitsComponent({offerType}) {
        const isMembershipFlexibilityD = Odigeo.Membership.isMembershipFlexibilityD;
        const isFreeTrialAbuser = this.isFreeTrialAbuser();
        const {
            offerMembershipHeaderTitlePill,
        } = this.updatedKeys;
        let benefits = [];

        if (offerType === OFFER_TYPES.FULL_FARE ) {
            if (isFreeTrialAbuser) {
                const {
                    offerFullFareBenefitsOne,
                    offerFullFareBenefitsTwo,
                    offerFullFareBenefitsThree,
                    offerFullFareBenefitsFour,
                } = this.updatedKeys;
                benefits = [
                    offerFullFareBenefitsOne,
                    offerFullFareBenefitsTwo,
                    offerFullFareBenefitsThree,
                    offerFullFareBenefitsFour,
                ];
            } else {
                return EMPTY_STRING;
            }
        } else {
            const {
                offerPrimeFareBenefitsOne,
                offerPrimeFareBenefitsTwo,
                offerPrimeFareBenefitsThree,
                offerPrimeFareBenefitsFlexibility,
                offerPrimeFareBenefitsFlexibilityPill,
                offerPrimeFareBenefitsFlexibilityExtra,
                offerPrimeFareBenefitsFour,
            } = this.updatedKeys;
            const stringsFromKeys = [
                offerPrimeFareBenefitsOne,
                offerPrimeFareBenefitsTwo,
                offerPrimeFareBenefitsThree,
                offerPrimeFareBenefitsFour,
            ];
            benefits = stringsFromKeys.filter((text) => text);

            if (isMembershipFlexibilityD) {
                benefits.splice(1, 0, this.templates.offerBenefitFlexibility({
                    benefit: offerPrimeFareBenefitsFlexibility,
                    pill: offerPrimeFareBenefitsFlexibilityPill,
                    extra: offerPrimeFareBenefitsFlexibilityExtra,
                }));
            }
        }
        return this.templates.offerBenefits({
            isPrimeFare: offerType === OFFER_TYPES.PRIME_FARE,
            benefits,
            offerMembershipHeaderTitlePill,
            isMembershipFlexibilityD,
        });
    },
    buildOfferFooterTemplate({offerType, hasBasicAccount}) {
        if (offerType === OFFER_TYPES.FULL_FARE) {
            return EMPTY_STRING;
        }
        let {offerPrimeFareTermsLink,
            offerPrimeFareCommonTermsText,
            offerPrimeFareTermsLinkText} = this.keys;
        const {primeFarePositiveMessage} = this.updatedKeys;
        offerPrimeFareCommonTermsText = Odigeo.Utils.replaceCmsKeyArgs(
            offerPrimeFareCommonTermsText,
            this.buildTermsLink(offerPrimeFareTermsLinkText, offerPrimeFareTermsLink),
        );
        const offerPrimeFareTermsText = `${offerPrimeFareCommonTermsText} ${this.getOfferPrimeFareTermsText({hasBasicAccount})}`;

        return this.templates.offerFooter({
            offerPrimeFareTermsText,
            primeFarePositiveMessage,
        });
    },
    getOfferPrimeFareTermsText({hasBasicAccount}) {
        const {offerPrimeFareNewAccountTermsText,
            offerPrimeFareExistingAccountTermsText, offerPrimeFareAskLoginLink} = this.keys;
        return !isUserLogged() && hasBasicAccount ? Odigeo.Utils.replaceCmsKeyArgs(offerPrimeFareExistingAccountTermsText,
            this.buildLoginLink(offerPrimeFareAskLoginLink)) : offerPrimeFareNewAccountTermsText;
    },
    buildOfferKnowMoreTemplate({offerType}) {
        if (offerType === OFFER_TYPES.FULL_FARE) {
            return EMPTY_STRING;
        }
        return this.templates.offerKnowMore({
            isDynpack,
        });
    },
    buildOfferDescriptionTemplate({offerType, isFullFareChecked = false}) {
        let {offerFullFareDescription} = this.updatedKeys;
        let classDescription = 'odf-text-mono-color-02';
        const isFreeTrialAbuser = this.isFreeTrialAbuser();
        let classSpace = this.getOfferDescriptionSpace({offerType, isFullFareChecked});
        if (offerType === OFFER_TYPES.PRIME_FARE) {
            if (isFreeTrialAbuser) {
                const {price} = this.model.get('membershipOffer');
                let {abuseBlueMessage} = this.updatedKeys;
                offerFullFareDescription = Odigeo.Utils.replaceCmsKeyArgs(abuseBlueMessage, price);
                classDescription = 'odf-text-info';
            } else {
                return EMPTY_STRING;
            }
        }
        return this.templates.offerDescription({
            offerFullFareDescription,
            classSpace,
            classDescription,
        });
    },
    getOfferDescriptionSpace({offerType, isFullFareChecked}) {
        let classSpace = '';
        const isFullFare = offerType === OFFER_TYPES.FULL_FARE;
        const isFreeTrialAbuser = this.isFreeTrialAbuser();
        if (isFullFare && !isFullFareChecked) {
            classSpace = 'odf-space-inner-bottom-l';
        } else if (!isFreeTrialAbuser && isFullFare && isFullFareChecked) {
            classSpace = 'odf-space-inner-bottom-m';
        } else {
            classSpace = '';
        }
        return classSpace;
    },
    buildOfferWarningTemplate({offerType, isFullFareChecked = false, membershipDiscount}) {
        const isFreeTrialAbuser = this.isFreeTrialAbuser();
        if (offerType === OFFER_TYPES.PRIME_FARE) {
            return EMPTY_STRING;
        }
        let {offerFullFareWarning, offerFlexibilityFullFareWarning} = this.keys;

        offerFullFareWarning = this.isAirlineOfferingFreeFlexibility() ? offerFlexibilityFullFareWarning : offerFullFareWarning;
        offerFullFareWarning = Odigeo.Utils.replaceCmsKeyArgs(offerFullFareWarning, membershipDiscount);
        return this.templates.offerWarning({
            offerFullFareWarning,
            isFullFareChecked,
            isFreeTrialAbuser,
        });
    },

    isAirlineOfferingFreeFlexibility() {
        return !isSelectedFlightChangeableForFree() && Odigeo.Membership.isMembershipFlexibilityD;
    },
    buildLoginLink(offerPrimeFareAskLoginLink) {
        return `<a class="odf-text-info odf-link-legal odf-link-md membership_ancillaries_open_login">
            ${offerPrimeFareAskLoginLink}
        </a>`;
    },
    buildTermsLink(offerPrimeFareTermsLinkText, offerPrimeFareTermsLink) {
        return `<a class="odf-link-legal odf-link-xs" href="${offerPrimeFareTermsLink}" target="_blank">${offerPrimeFareTermsLinkText}</a>`;
    },
    buildFareDiscount({isPrimeFareSelected = false, offerType, membershipDiscount}) {
        const offerZero = Odigeo.Utils.formatCurrency(OFFER_ZERO);
        const sign = (isPrimeFareSelected) ? SIGN_PLUS : SIGN_MINUS;

        if (isPrimeFareSelected && offerType === OFFER_TYPES.PRIME_FARE) {
            return `${sign} ${offerZero}`;
        } else if (isPrimeFareSelected && offerType === OFFER_TYPES.FULL_FARE) {
            return `${sign} ${membershipDiscount}`;
        } else if (!isPrimeFareSelected && offerType === OFFER_TYPES.PRIME_FARE) {
            return `${sign} ${membershipDiscount}`;
        } else if (!isPrimeFareSelected && offerType === OFFER_TYPES.FULL_FARE) {
            return `${sign} ${offerZero}`;
        }
    },

    getScrollingEvent() {
        const {isRiskyCreditCard} = this.model.get('isRiskyCreditCard');
        const {isExpiringCreditCard} = this.model.get('isExpiringCreditCard');

        return isRiskyCreditCard ?
            'scrollToRiskyCardWarningMessage' : isExpiringCreditCard ?
                'scrollToExpiringCardWarningMessage' : null;
    },
    onChangeOffer(e) {
        const membershipInfo = this.model.get('membershipInfo');
        const primeMemberSelected = this.model.get('primeMemberSelected') || {};
        const offerSelectedFromModel = primeMemberSelected.isSubscriptionAdded ? OFFER_TYPES.PRIME_FARE : OFFER_TYPES.FULL_FARE;
        const offerSelected = e && $(e.currentTarget).data('offer') || offerSelectedFromModel;
        const quantity = offerSelected === OFFER_TYPES.FULL_FARE ? 0 : 1;
        const isFullFareChecked = offerSelected === OFFER_TYPES.FULL_FARE;
        const scrollingEvent = this.getScrollingEvent();
        this.model.set({
            quantity,
            membershipInfo: {...membershipInfo, quantity},
            isPrimeFareSelected: !isFullFareChecked,
        });
        const variation = this.getTrackingInfo();
        const label = `${isFullFareChecked ? 'standard_fare' : 'prime_fare'}_click_sce:${variation}_pag:${page}`;

        if (!isFullFareChecked && scrollingEvent) {
            Odigeo.trigger(`${this.id}:${scrollingEvent}`);
            return false;
        }

        this.tracking(TRACKING.ACTIONS.PRIME_SELECTION, label);
        this.executeChangeOffer(offerSelected, isFullFareChecked, quantity);
        Odigeo.trigger(`${this.id}:shouldRequestForRiskyCardNumber`, offerSelected);
        Odigeo.trigger(`${this.id}:showMembershipPaymentMethodDisclaimer`, offerSelected);
        this.model.set({
            isPrimeDecisionTaken: true,
        });
        this.toggleShowPendingPrimeDecisionMessage();
    },
    requestForRiskyCardNumber(ccnumber) {
        const binCCNumber = creditCardUtils.getPCIBinCCNumber(ccnumber);
        const forceUpdate = true;
        setTimeout(() => Odigeo.trigger(`${this.id}:checkRiskyCard`, binCCNumber, forceUpdate), REQUEST_FOR_RISKY_CC_TIMEOUT);
    },
    toggleAskLoginText() {
        this.$el.find(this.$cachedSelectors.offerPrimeFareAskLogin)
            .addClass('odf-hidden');
    },
    toggleShowPrimeFarePositiveMessage(offerSelected) {
        this.$el.find(this.$cachedSelectors.offerPrimeFarePositiveMessageContainer)
            .toggleClass('odf-hidden', offerSelected !== OFFER_TYPES.PRIME_FARE)
            .toggleClass('membership-ancillaries-prime-fare-message-animation', offerSelected === OFFER_TYPES.PRIME_FARE);
    },
    toggleWarning({offerSelected = OFFER_TYPES.PRIME_FARE}) {
        this.$el.find(this.$cachedSelectors.membershipAncillariesWarning)
            .toggleClass('odf-hidden', offerSelected === OFFER_TYPES.PRIME_FARE);
    },
    toggleAbuseMessages({offerSelected = OFFER_TYPES.PRIME_FARE}) {
        this.$el.find(this.$cachedSelectors.fullFareOffer).find(this.$cachedSelectors.offerBenefitsList)
            .toggleClass('odf-hidden', offerSelected === OFFER_TYPES.PRIME_FARE);
    },
    executeChangeOffer(offerSelected, isFullFareChecked, quantity) {
        this.toggleWarning({offerSelected});
        this.toggleShowPrimeFarePositiveMessage(offerSelected);
        if (this.isFreeTrialAbuser()) {
            this.toggleAbuseMessages({offerSelected});
        }
        const descriptionComponent = this.buildOfferDescriptionTemplate({offerType: OFFER_TYPES.FULL_FARE, isFullFareChecked});
        this.$cachedSelectors.fullFareOffer.find(this.$cachedSelectors.offerDescription).html(descriptionComponent);
        this.model.propagateMembershipProduct(this.id, quantity === 1);
    },
    addPrime(isFullFareSelected) {
        const {isRiskyCreditCard} = this.model.get('isRiskyCreditCard');
        const {isExpiringCreditCard} = this.model.get('isExpiringCreditCard');

        if (!isRiskyCreditCard || !isExpiringCreditCard) {
            this.executeChangeOffer(OFFER_TYPES.PRIME_FARE, isFullFareSelected, 1);
            this.$el.find('.membership_ancillaries_radio_input[data-offer="PRIME_FARE"]').prop('checked', true);
        }
    },
    removePrime(isFullFareSelected) {
        this.executeChangeOffer(OFFER_TYPES.FULL_FARE, isFullFareSelected, 0);
        this.$el.find('.membership_ancillaries_radio_input[data-offer="FULL_FARE"]').prop('checked', true);
    },
    onOpenLoginForm() {
        const variation = this.getTrackingInfo();
        this.tracking(TRACKING.ACTIONS.EXISTING_ACCOUNT, `existing_account_log_in_sce:${variation}_pag:${page}`);
        Odigeo.trigger(`${this.id}:openLoginForm`);
    },
    onTermsConditions() {
        const variation = this.getTrackingInfo();
        this.tracking(TRACKING.ACTIONS.TERMS_CONDITIONS, `prime_terms_conditions_sce:${variation}_pag:${page}`);
    },
    tracking(action, label) {
        trackingUtils.trackEventWithCategory(trackingCategory, action, label);
    },
    getTrackingInfo() {
        const isFullFareSelectedResults = getResultFullFareSelected();
        const fareSelectedLabel = isFullFareSelectedResults ? 'no-prime' : 'prime';
        const abuseTracking = this.getAbuseTrackingLabel();
        return `${fareSelectedLabel}${isUserLogged() ? '-log' : ''}${abuseTracking}`;
    },
    getAbuseTrackingLabel() {
        if (Odigeo.Membership.isFreeTrialLimitationActive) {
            const {membershipSubscriptionDetails} = this.model.get('primeStatus') || {};
            const isFreeTrialCandidate = membershipSubscriptionDetails && membershipSubscriptionDetails.freeTrialCandidate;
            return `_user:${isFreeTrialCandidate ? 'freetrial' : 'expired'}_`;
        }
        return '';
    },
    trackPage() {
        const cookieRememberMe = Odigeo.Utils.readCookie('sso_remember_me');
        const decodedCookieRememberMe = cookieRememberMe ? decodeURIComponent(cookieRememberMe).split(';') : [];
        const cDimension15 = decodedCookieRememberMe.length > 0 ? 'SSO_1': 'SSO_0';
        const cDimension31 = decodedCookieRememberMe[2] === 'true' ? 'subscriber' : 'non-subscriber';
        trackingUtils.trackPage('payment', {
            customDimensions: {
                'dimension15': cDimension15,
                'dimension31': cDimension31,
            },
        });
    },
    trackRender() {
        this.trackPage();
        this.trackingPrimeWidget();
    },

    trackRenderWithoutPage() {
        this.trackingPrimeWidget();
    },

    trackingPrimeWidget() {
        const variation = this.getTrackingInfo();
        this.tracking(TRACKING.ACTIONS.PRIME, `prime_widget_sce:${variation}_pag:${page}`);
    },

    toggleShowPendingPrimeDecisionMessage() {
        if (!Odigeo.SessionScope.isMeta || this.isFreeTrialMetaRevamp()) {
            const isShowPendingDecisionBanner = !this.model.get('isPrimeDecisionTaken');
            this.$el.find(pendingPrimeDecisionMessage).toggleClass('odf-hidden', !isShowPendingDecisionBanner);
            if (isShowPendingDecisionBanner) {
                const variation = this.getTrackingInfo();
                trackingUtils.trackEventWithCategory(
                    trackingCategory,
                    TRACKING.ACTIONS.PRIME, `continue_with_error_sce:${variation}_pag:${page}`
                );
                Odigeo.Utils.scrollToElement(this.$el.find(pendingPrimeDecisionMessage));
            }
            return isShowPendingDecisionBanner;
        }
    },
    isFreeTrialAbuser() {
        const {membershipSubscriptionDetails} = this.model.get('primeStatus') || {};
        const isFreeTrialCandidate = membershipSubscriptionDetails.freeTrialCandidate;
        return Odigeo.Membership.isFreeTrialLimitationActive && !isFreeTrialCandidate;
    },

    isFreeTrialMetaRevamp() {
        return Odigeo.Membership.isFreeTrialMetaRevampDesktop;
    },
}));
